import { IModel, Model, PaymentMethodModel, IPaymentMethodModel } from ".";

export interface IInvoicePaymentModel extends IModel {
    invoicePaymentId: number;
    paymentMethodId: number;
    invoiceId: number;
    amount: number;
    dateCreated: string;
    paymentMethod: IPaymentMethodModel;
}[]

export class InvoicePaymentModel extends Model implements IInvoicePaymentModel {
    invoicePaymentId: number;
    paymentMethodId: number;
    invoiceId: number;
    amount: number;
    dateCreated: string;
    paymentMethod: PaymentMethodModel;
    constructor(params: IInvoicePaymentModel) {
        super(params);
        this.invoicePaymentId = params.invoicePaymentId
        this.paymentMethodId = params.paymentMethodId
        this.invoiceId = params.invoiceId
        this.amount = params.amount
        this.dateCreated = params.dateCreated
        this.paymentMethod = new PaymentMethodModel(params.paymentMethod)
    }
}
